import AddPromiseTemplate from '../templates/promise/addPromiseTemplate.html';
import UpdateOwnerTemplate from '../templates/promise/updateOwnerTemplate.html';

export default class AddPromise {
  constructor($uibModal, $rootScope, enums, appConfig, authService, promiseService) {
    "ngInject";

    this.$scope = $rootScope.$new();
    this.$uibModal = $uibModal;
    this.authService = authService;
    this.appConfig = appConfig;

    this.$scope.promiseService = promiseService;
    this.$scope.authService = authService;
    this.$scope.enums = enums;
    this.$scope.categories = this.convertEnumToKeyValueList(enums.PROMISE_CATEGORY, true);
    this.$scope.addPromise = this.addPromise;
    this.$scope.validateForm = this.validateForm;
    this.$scope.checkCurrentTime = this.checkCurrentTime;
    this.$scope.getFullDateTime = this.getFullDateTime;
    this.$scope.contactSelected = this.contactSelected.bind(this.$scope);
    this.$scope.searchContactUrl = `${appConfig.apiServiceBaseUri}api/contact/search/${authService.authData.currentLocation.key}/`;
    this.$scope.getPromiseFromForm = this.getPromiseFromForm;
    this.$scope.closeModal = this.closeModal;
    this.$scope.addPromiseSuccess = this.addPromiseSuccess;
    this.$scope.searchUsersUrl = `${appConfig.apiServiceBaseUri}api/user/search/${authService.authData.currentLocation.key}/`;
    this.$scope.initialOwnerName = authService.authData.firstName + ' ' + authService.authData.lastName;
    this.$scope.ownerSelected = this.ownerSelected.bind(this.$scope);
    this.$scope.updateOwner = this.updateOwner;
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  showAddPromise(successHandler, noSave, noteText, contact, addPromiseConfirmation) {
    this.$scope.searchContactUrl = `${this.appConfig.apiServiceBaseUri}api/contact/search/${this.authService.authData.currentLocation.key}/`;
    this.$scope.searchUsersUrl = `${this.appConfig.apiServiceBaseUri}api/user/search/${this.authService.authData.currentLocation.key}/`;

    this.$scope.errMsg = "";
    this.$scope.tempPromise = {
      category: this.$scope.categories[0]
    };
    this.$scope.addPromiseConfirmation = addPromiseConfirmation;

    if (noteText) {
      this.$scope.tempPromise.subject = noteText.substring(0, 200);
    }

    if (contact) {
      this.$scope.tempPromise.category = this.$scope.categories[1];
      this.$scope.tempPromise.contactId = contact.contactId;
      this.$scope.tempPromise.contactName = contact.contactName;
    }

    this.$scope.successHandler = successHandler;
    this.$scope.noSave = noSave;

    this.$scope.datePickerOptions = {
      minDate: new Date(),
      showButtonBar: false
    };

    this.$scope.modalInstance = this.$uibModal.open({
        template: AddPromiseTemplate,
        scope: this.$scope
    });
  }

  closeModal() {
    const scope = this;

    if (scope.modalInstance) {
      scope.modalInstance.close();
    }
  }

  addPromise() {
    const scope = this;

    if (!scope.validateForm()) {
      return;
    }

    const promiseToAdd = scope.getPromiseFromForm();

    if (scope.noSave) {
      scope.addPromiseSuccess(promiseToAdd);
    }
    else {
      scope.promiseService.addPromise(promiseToAdd)
        .then(response => {
          scope.addPromiseSuccess(response.data);
        });
    }
  }

  addPromiseSuccess(promiseToAdd) {
    const scope = this;

    scope.closeModal();

    if (scope.successHandler) {
      scope.successHandler(promiseToAdd);
    }
  }

  validateForm() {
    const scope = this;

    if (!scope.tempPromise.subject) {
      scope.errMsg = 'Please enter some text for the subject';
      return false;
    }

    if (!scope.tempPromise.category.id) {
      scope.errMsg = 'Please select a category';
      return false;
    }

    if (scope.tempPromise.category.id === scope.enums.PROMISE_CATEGORY.Customer && !scope.tempPromise.contactId) {
      scope.errMsg = 'Please select a contact';
      return false;
    }

    if (!scope.tempPromise.date) {
      scope.errMsg = 'Please select a due date';
      return false;
    }

    if (!scope.tempPromise.time) {
      scope.errMsg = 'Please select a due time';
      return false;
    }

    if (scope.checkCurrentTime()) {
      scope.errMsg = 'Due Date cannot be in the past';
      return false;
    }

    return true;
  }

  getPromiseFromForm() {
    const scope = this;

    return {
      ownerId: this.tempPromise.ownerId || scope.authService.authData.userId,
      subject: scope.tempPromise.subject,
      category: scope.tempPromise.category.id,
      dueDate: scope.getFullDateTime(),
      contactId: scope.tempPromise.contactId
    };
  }

  getFullDateTime() {
    const scope = this;

    const dt = `${scope.tempPromise.date.getFullYear()}-${(scope.tempPromise.date.getMonth() + 1)}-${scope.tempPromise.date.getDate()}`;
    const time = `${scope.tempPromise.time.getHours()}:${(scope.tempPromise.time.getMinutes())}`;

    return `${dt} ${time}`
  }

  checkCurrentTime() {
    return new Date(this.getFullDateTime()) < new Date();
  }

  contactSelected(item) {
    if (item) {
      this.tempPromise.contactId = item.originalObject.contactId;
    }
  }

  ownerSelected(item) {
    if (item) {
      this.tempPromise.ownerId = item.originalObject.userId;
    }
  }

  showUpdateOwner(promiseId, successHandler) {
    this.$scope.tempPromise = {
      ownerId: this.authService.authData.userId
    };
    this.$scope.initialOwnerName = this.authService.authData.firstName + ' ' + this.authService.authData.lastName;

    this.$scope.errMsg = "";
    this.$scope.promiseId = promiseId;
    this.$scope.successHandler = successHandler;

    this.$scope.modalInstance = this.$uibModal.open({
        template: UpdateOwnerTemplate,
        scope: this.$scope
    });
  }

  updateOwner() {
    const scope = this;
    
    scope.promiseService.updateOwner(scope.promiseId, this.tempPromise.ownerId)
      .then(response => {
        scope.addPromiseSuccess();
      });
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/addPromiseService.js